module.exports = __webpack_public_path__ + "static/media/8.5e9bbbad.png";